import React from "react";

import Text from "src/components/text";

import _ from "lodash";
import styles from "./styles.module.scss";
import { UserGroup } from "src/types/users";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface ShareListItem {
  userGroup: UserGroup;
  analytics: Analytics;
}

export interface TopSharedUserGroupsListCardProps {
  item: ShareListItem;
  columnCount: number;
}

export const TopSharedUserGroupsListCard: React.FC<TopSharedUserGroupsListCardProps> = ({
  item,
  columnCount,
}) => {
  const { userGroup, analytics } = item;
  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={userGroup.icon?.thumbnail || DefaultAssetIcon}
          className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
          alt={userGroup.name}
        />
        <div className={styles.rightData}>
          <div className={styles.tableDataTitle}>
            <Text
              lines={1}
              className={styles.title}
              text={userGroup.name}
            />
          </div>
        </div>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{userGroup.usersCount}</div>
        <div className={styles.tableDataViews}>{analytics.shares}</div>
        <div className={styles.tableDataTime}>{analytics.assets}</div>
      </div>
    </div>
  );
};
